<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select v-model="listQuery.tenantId" placeholder="选择租户" clearable style="width: 200px" class="filter-item">
        <el-option v-for="item in tenantList" :key="item.tenantId" :label="item.name" :value="item.tenantId" />
      </el-select>
      <el-input v-model="listQuery.nickname" placeholder="用户昵称" clearable style="width: 150px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-input v-model="listQuery.phone" placeholder="手机号" clearable style="width: 150px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-input v-model="listQuery.tag" placeholder="标签" clearable style="width: 150px;" class="filter-item" @keyup.enter.native="handleFilter" />
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="用户ID" prop="userId" align="center" width="80" />
      <el-table-column label="OpenID" prop="openId" align="center" width="200" />
      <el-table-column label="昵称" prop="globalNickname" align="center" width="150" />
      <el-table-column label="手机号" prop="phone" align="center" width="120" />
      <el-table-column label="头像" align="center" width="80">
        <template slot-scope="{row}">
          <el-avatar v-if="row.globalAvatarUrl" :src="row.globalAvatarUrl" size="small" />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="标签" align="center" width="200">
        <template slot-scope="{row}">
          <el-tag v-for="tag in (row.tags || [])" :key="tag" size="mini" style="margin-right: 3px">{{ tag }}</el-tag>
          <span v-if="!row.tags || row.tags.length === 0">-</span>
        </template>
      </el-table-column>
	  <el-table-column label="租户" prop="tenantName" align="center" width="120" />
      <el-table-column label="最后沟通时间" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.lastSeenAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="首次访问时间" align="center" width="160">
        <template slot-scope="{row}">
          <span>{{ row.firstSeenAt | parseTime }}</span>
        </template>
      </el-table-column>
      <el-table-column label="访问次数" prop="totalVisits" align="center" width="80" />
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="{row}">
          <el-button type="primary" size="mini" @click="handleViewMessages(row)">查看记录</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize" @pagination="getList" />

    <el-dialog :title="'聊天记录 - ' + currentUserName + '（' + currentTenantName + '）'" :visible.sync="dialogVisible" width="800px" top="5vh">
      <div class="dialog-filter">
        <el-date-picker
          v-model="msgQuery.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          style="width: 380px; margin-right: 10px;"
          @change="handleDateChange"
        />
        <el-input v-model="msgQuery.keyword" placeholder="关键字" style="width: 160px; margin-right: 10px;" clearable @keyup.enter.native="getMessages" />
        <el-button type="primary" size="small" @click="getMessages">查询</el-button>
      </div>
      <div class="messages-container" v-loading="msgLoading">
        <div v-if="messages.length === 0" class="empty-message">
          <el-empty description="暂无聊天记录" />
        </div>
        <div v-else class="message-list">
          <div v-for="msg in messages" :key="msg.messageId" class="message-item" :class="msg.senderType">
            <div class="message-avatar">
              <el-avatar :src="msg.senderAvatar" size="small" />
            </div>
            <div class="message-content">
              <div class="message-header">
                <span class="sender-name">{{ msg.senderName || (msg.senderType === 'agent' ? '客服' : '用户') }}</span>
                <span class="message-time">{{ msg.createdAt | parseTime }}</span>
              </div>
              <div class="message-body">
                <div v-if="msg.contentType === 'text'" class="text-message" v-html="renderContent(msg.content)"></div>
                <div v-else-if="msg.contentType === 'image'" class="image-message">
                  <el-image :src="msg.content" :preview-src-list="[msg.content]" style="max-width: 150px; max-height: 150px" />
                </div>
                <div v-else-if="msg.contentType === 'file'" class="file-message">
                  <el-link :href="msg.content" target="_blank" type="primary">
                    <i class="el-icon-document" /> {{ msg.fileName || '下载文件' }}
                  </el-link>
                </div>
                <div v-else class="text-message" v-html="renderContent(msg.content)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog-pagination">
        <el-pagination
          :current-page="msgQuery.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="msgQuery.pageSize"
          :total="msgTotal"
          layout="total, sizes, prev, pager, next"
          @size-change="handleMsgSizeChange"
          @current-change="handleMsgPageChange"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getChatRecordUsers, getUserChatMessages } from '@/api/tenantUser'
import { listTenants } from '@/api/tenant'
import Pagination from '@/components/Pagination'

export default {
  name: 'ChatRecords',
  components: { Pagination },
  filters: {
    parseTime(time) {
      if (!time) return ''
      const date = new Date(time)
      return date.toLocaleString()
    }
  },
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      tenantList: [],
      listQuery: {
        tenantId: undefined,
        nickname: '',
        phone: '',
        tag: '',
        pageNum: 1,
        pageSize: 10
      },
      dialogVisible: false,
      currentUserId: null,
      currentTenantId: null,
      currentTenantName: '',
      currentUserName: '',
      messages: [],
      msgTotal: 0,
      msgLoading: false,
      msgQuery: {
        pageNum: 1,
        pageSize: 20,
        dateRange: null,
        keyword: ''
      }
    }
  },
  created() {
    this.getTenantList()
  },
  methods: {
    getTenantList() {
      listTenants({ pageNum: 1, pageSize: 1000 }).then(response => {
        this.tenantList = response.data.records || []
        this.getList()
      })
    },
    getList() {
      this.listLoading = true
      getChatRecordUsers(this.listQuery).then(response => {
        this.list = response.data.records || []
        this.total = response.data.total || 0
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.pageNum = 1
      this.getList()
    },
    handleViewMessages(row) {
      this.currentUserId = row.userId
      this.currentTenantId = row.tenantId
      this.currentTenantName = row.tenantName || ''
      this.currentUserName = row.globalNickname || row.openId || row.userId
      this.msgQuery.pageNum = 1
      this.msgQuery.dateRange = null
      this.msgQuery.keyword = ''
      this.dialogVisible = true
      this.getMessages()
    },
    handleDateChange() {
      this.msgQuery.pageNum = 1
    },
    getMessages() {
      this.msgLoading = true
      const params = {
        tenantId: this.currentTenantId,
        pageNum: this.msgQuery.pageNum,
        pageSize: this.msgQuery.pageSize
      }
      if (this.msgQuery.dateRange && this.msgQuery.dateRange.length === 2) {
        params.startDate = this.msgQuery.dateRange[0]
        params.endDate = this.msgQuery.dateRange[1]
      }
      if (this.msgQuery.keyword) {
        params.keyword = this.msgQuery.keyword
      }
      getUserChatMessages(this.currentUserId, params).then(response => {
        this.messages = response.data.records || []
        this.msgTotal = response.data.total || 0
        this.msgLoading = false
      }).catch(() => {
        this.msgLoading = false
      })
    },
    handleMsgSizeChange(val) {
      this.msgQuery.pageSize = val
      this.msgQuery.pageNum = 1
      this.getMessages()
    },
    handleMsgPageChange(val) {
      this.msgQuery.pageNum = val
      this.getMessages()
    },
    renderContent(content) {
      if (!content) return ''
      const emojiPattern = /\[em:(\d+)\]/g
      return content.replace(emojiPattern, (match, index) => {
        return `<img src="/em_${index}.png" class="emoji-img" alt="${match}" />`
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.filter-item {
  margin-right: 10px;
}
.dialog-filter {
  margin-bottom: 15px;
}
.dialog-pagination {
  margin-top: 15px;
  text-align: right;
}
.messages-container {
  min-height: 400px;
  max-height: 55vh;
  overflow-y: auto;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}
.empty-message {
  padding: 50px 0;
}
.message-list {
  display: flex;
  flex-direction: column;
}
.message-item {
  display: flex;
  margin-bottom: 15px;
}
.message-item.user {
  flex-direction: row;
}
.message-item.agent {
  flex-direction: row-reverse;
}
.message-avatar {
  flex-shrink: 0;
}
.message-content {
  max-width: 70%;
  margin: 0 10px;
}
.message-header {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.message-item.agent .message-header {
  flex-direction: row-reverse;
}
.sender-name {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}
.message-time {
  font-size: 12px;
  color: #c0c4cc;
}
.message-body {
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
.message-item.user .message-body {
  background: #e6f7ff;
}
.message-item.agent .message-body {
  background: #f0f9eb;
}
.text-message {
  word-break: break-word;
  line-height: 1.5;
  font-size: 14px;
}
.image-message {
  overflow: hidden;
}
.file-message {
  padding: 3px 0;
}
.emoji-img {
  width: 20px !important;
  height: 20px !important;
  vertical-align: middle;
  display: inline-block;
}
::v-deep .emoji-img {
  width: 20px !important;
  height: 20px !important;
  vertical-align: middle;
  display: inline-block;
}
</style>
